export default __webpack_public_path__ + "static/media/bolt.5d6d5f60.svg";